// Central gsap setup: registering plugins/eases here once (instead of in every
// component that uses gsap) avoids bundling duplicate copies of gsap + its
// plugins into every page/component chunk.
import gsap from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { SplitText } from 'gsap/SplitText';
import { CustomEase } from 'gsap/dist/CustomEase';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger, SplitText, CustomEase);
gsap.config({ nullTargetWarn: false });

CustomEase.create('curveNatural', '.4,0,.2,1');
CustomEase.create('curveAppear', '.03,0,.2,1');
CustomEase.create('curveTech', '.2,0,.8,1');

export default gsap;
export { DrawSVGPlugin, SplitText, CustomEase, ScrollTrigger };
